import { captureMessage, captureException } from '@sentry/react';
import { loadScript } from '@/utils';
import { styles } from '../contacts/mapStyles';

interface ObjectMapOptions {
  apiKey: string;
  displayLat: number;
  displayLng: number;
  circleRadius: number;
}

const initObjectMap = (lang: string, options: ObjectMapOptions, delay?: number): void => {
  const {
    apiKey,
    displayLat,
    displayLng,
    circleRadius
  } = options;

  const center = {
    lat: displayLat,
    lng: displayLng
  };

  (window as Window & {
    onObjectMapLoaded?: () => void
  }).onObjectMapLoaded = () => {
    const mapContainer = document.getElementById('object-map');

    if (!mapContainer) {
      captureMessage('initObjectMap: element #object-map not found', { level: 'warning' });
      return;
    }

    try {
      const map = new google.maps.Map(mapContainer, {
        zoom: 14,
        center,
        scrollwheel: false,
        zoomControl: true,
        styles,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      });

       
      new google.maps.Circle({
        map,
        center,
        radius: circleRadius,
        strokeColor: '#c9a96e',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#c9a96e',
        fillOpacity: 0.2
      });
    } catch (e) {
      captureException(e, {
        extra: {
          context: 'object_map_init',
          center
        }
      });
    }
  };

  const url = `//maps.googleapis.com/maps/api/js?key=${apiKey}&language=${lang}&callback=onObjectMapLoaded`;

  if (delay) {
    setTimeout(() => loadScript('objectMap', url), delay);
  } else {
    loadScript('objectMap', url);
  }
};

export default initObjectMap;
